import Box from '@mui/material/Box'

/*
 * `as` lets a heading be given real document semantics (as="h1",
 * as="h2") without changing how it looks. It defaults to a div, so
 * every existing call site renders exactly as it did before.
 *
 * Note that the remaining props are spread into `sx` rather than onto
 * the element, which is why `as` is destructured out here and not
 * picked up as a style key.
 */
export default function Heading ({
  children,
  width,
  textAlign,
  color,
  fontWeight,
  fontSize,
  as = 'div',
  ...props
}) {
  return (
    <Box
      component={as}
      sx={{
        fontFamily: 'Bodoni Moda',
        width,
        textAlign,
        color,
        fontWeight,
        fontSize,
        ...props

      }}

    >
      {children}
    </Box>
  )
}
